<div [ngClass]="{'field': fieldStyles}">
    <label [for]="formControlName" class="font-medium text-900">
        {{label}}
     </label>
    <p-dropdown 
        [options]="options"
        optionLabel="name"
        [id]="formControlName"
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        (blur)="onTouched()"
        [disabled]="isDisabled"
        [filter]="filter" 
        [class.ng-invalid]="control.invalid && (control.dirty || control.touched)"
        [class.ng-dirty]="control.invalid && (control.dirty || control.touched)">
    </p-dropdown>
    <div *ngIf="control?.invalid && (control.dirty || control.touched)">
        <small class="text-red-400">{{errorMessage(control)}}</small>
    </div>
</div>